/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderVariance } from './OrderVariance';
// @ts-ignore
import {
// @ts-ignore
    OrderVarianceFromJSON,
// @ts-ignore
    OrderVarianceFromJSONTyped,
// @ts-ignore
    OrderVarianceToJSON,
} from './OrderVariance';

/**
 * 
 * @export
 * @interface StoreOrderVariance
 */
export interface StoreOrderVariance {
    /**
     * 
     * @type {string}
     * @memberof StoreOrderVariance
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOrderVariance
     */
    orderCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOrderVariance
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOrderVariance
     */
    storeId: string;
    /**
     * 
     * @type {Array<OrderVariance>}
     * @memberof StoreOrderVariance
     */
    variances: Array<OrderVariance>;
}

/**
 * Check if a given object implements the StoreOrderVariance interface.
 */
// @ts-ignore
export function instanceOfStoreOrderVariance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "variances" in value;

    return isInstance;
}

// @ts-ignore
export function StoreOrderVarianceFromJSON(json: any): StoreOrderVariance {
    return StoreOrderVarianceFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreOrderVarianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreOrderVariance {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderId': json['order_id'],
        'orderCode': !exists(json, 'order_code') ? undefined : json['order_code'],
        'supplierId': json['supplier_id'],
        'storeId': json['store_id'],
        'variances': ((json['variances'] as Array<any>).map(OrderVarianceFromJSON)),
    };
}

// @ts-ignore
export function StoreOrderVarianceToJSON(value?: StoreOrderVariance | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_id': value.orderId,
        'order_code': value.orderCode,
        'supplier_id': value.supplierId,
        'store_id': value.storeId,
        'variances': ((value.variances as Array<any>).map(OrderVarianceToJSON)),
    };
}

